import React from 'react';
import ReactDOMClient from 'react-dom/client';
import singleSpaReact from 'single-spa-react';
// eslint-disable-next-line import/no-unresolved
import './register-stencil-components';
import RootComponent from './root.component';
import './i18n';

const reactLifecycles = singleSpaReact({
  React,
  ReactDOM: ReactDOMClient,
  rootComponent: RootComponent,
  domElementGetter,
  renderType: 'createRoot'
});

export const bootstrap = [reactLifecycles.bootstrap];
export const mount = [reactLifecycles.mount];
export const unmount = [reactLifecycles.unmount];
export const unload = [reactLifecycles.unload];

function domElementGetter() {
  return document.getElementById('microfrontend_hook');
}
